import { useEffect } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { getUser } from "@jti/rest-api";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { fetchCart, fetchCurrency, fetchStoreConfig, fetchTrialCart } from "@jti/store/slices/cartSlice";
import { clearFreeTrialRedirect, isFreeTrialRedirect, redirectToTrialAuthWithBack } from "@jti/store/utils";
import { useAuthHrefResolver } from "@jti/ui/providers/AuthRoutingProvider";

import { useProductListener } from "../../hooks/useProductListener";

export const AppRunner = () => {
  const user = getUser();
  const dispatch = useDispatch();
  const { FREE_TRIAL_PAGE_URL } = useConfig();
  const resolveAuthHref = useAuthHrefResolver();
  const storeGroupCode = useSelector((state) => state.cart.storeConfig?.store_group_code);
  const fetchCurrencyStatus = useSelector((state) => state.cart.fetchCurrencyStatus);
  const fetchStoreConfigStatus = useSelector((state) => state.cart.fetchStoreConfigStatus);
  useProductListener();

  useEffect(() => {
    if (isFreeTrialRedirect()) {
      if (user?.email) {
        dispatch(fetchTrialCart({ useAnonymous: true }));
      } else {
        clearFreeTrialRedirect();
        redirectToTrialAuthWithBack(
          resolveAuthHref({
            route: AUTH_ROUTE_PATHS.login,
            search: { returnUrl: FREE_TRIAL_PAGE_URL },
          })
        );
      }
    }
    if (fetchCurrencyStatus === "idle") {
      dispatch(fetchCurrency());
    }
    if (fetchStoreConfigStatus === "idle") {
      dispatch(fetchStoreConfig());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FREE_TRIAL_PAGE_URL, dispatch, resolveAuthHref, user?.email]);

  useEffect(() => {
    if (storeGroupCode) {
      dispatch(fetchCart({ useAnonymous: true }));
    }
  }, [dispatch, storeGroupCode]);

  return <></>;
};
